import React from "react";
import axios from "@/utils/myAxios";
import moment from "moment";
import Cookie from "js-cookie";
import { kindList, subKindList } from "@/utils/constant";
import { Link } from "react-router-dom";
import { tableSummaries, isMobileDevice } from "@/utils/utils";
import {
    Button,
    Table,
    Pagination,
    message,
    Modal,
    Select,
    InputNumber,
    Switch,
    Popover,
    Badge,
    Tag,
    Form,
} from "antd";

let kindListFilter = kindList.filter(
    (item) => item.value !== 3 && item.value !== 5
);

// 表单数据
const formData = {
    keep_avail_tables: undefined,
}

export default class TableConfigStatistic extends React.Component {
    state = {
        type: undefined, // 弹窗类型
        title: undefined, // 弹窗标题
        show: false, // 是否显示弹窗
        loading: false, // 是否加载中
        queryParams: {
            // 查询参数
            page: 1,
            limit: 20,
            total: 0,
            game_kind: undefined,
        },
        data: [], // 表格数据
        kindList: kindListFilter, // 游戏类型列表
        subKindList: subKindList, // 游戏二级类型列表
        formData: { ...formData }, // 表单数据
        selectedData: {}, // 选中的表格数据
        diamondBalance: 0, // 余额数据
    };

    componentDidMount () {
        this.fetchData();
        this.fetchDiamondBalance();
    }

    /**
     * 获取数据
     */
    fetchData = () => {
        this.setState({ loading: true });
        axios
            .get("/v1/api/get_match_statistical", {
                params: {
                    ...this.state.queryParams,
                    total: undefined,
                },
            })
            .then((res) => {
                if (res.data && res.data.length) {
                    res.data.forEach((item) => {
                        item.level = JSON.parse(item.level);
                    });
                }
                this.setState({
                    loading: false,
                    queryParams: { ...this.state.queryParams, total: res.count || 0 },
                    data: res.data || [],
                });
            });
    };

    /**
     * 获取余额数据
     */
    fetchDiamondBalance = async () => {
        const res = await axios.get("/v1/api/union_club_user_wallet");
        this.setState({
            diamondBalance: res.data.diamond || 0,
        });
    };

    /**
     * 创建牌局
     */
    handleCreateRound = (id) => {
        Modal.confirm({
            title: this.props.language["hint"],
            content: this.props.language["createConfirm"],
            onOk: () => {
                axios.post("/v1/api/create_match", { conf_id: id }).then((res) => {
                    if (res.code === 1) {
                        message.success(this.props.language["createSuccessMessage"]);
                        this.fetchData();
                    }
                });
            },
        });
    };

    /**
     * 设置是否自动开桌
     */
    handleSetAutoCreateTable = (conf_id, value) => {
        axios
            .patch("/v1/api/set_auto_create_tables", {
                conf_id: conf_id,
                open: value,
            })
            .then((res) => {
                if (res.code === 1) {
                    message.success(this.props.language["setSuccessMessage"]);
                    this.fetchData();
                }
            });
    };

    /**
     * 关闭所有桌子
     */
    handelCloseAllTable = () => {
        Modal.confirm({
            title: this.props.language["hint"],
            content: this.props.language["closeAllConfirm"],
            onOk: () => {
                axios
                    .post("/v1/api/close_all_match_tables")
                    .then((res) => {
                        if (res.code === 1) {
                            message.success(this.props.language["closeSuccessMessage"]);
                            this.fetchData();
                        }
                    });
            },
        });
    };

    /**
     * 提交表单
     */
    handleSubmit = () => {
        this.formRef.props.form.validateFields((err, values) => {
            if (!err) {
                if (this.state.type === "tableNumber") {
                    // 更新最少空位牌桌
                    axios
                        .patch("/v1/api/set_keep_avail_tables", {
                            conf_id: this.state.selectedData.conf_id,
                            keep_avail_tables: values.keep_avail_tables,
                        })
                        .then((res) => {
                            if (res.code === 1) {
                                message.success(this.props.language["operationSuccessMessage"]);
                                this.handleClose();
                                this.fetchData();
                            }
                        });
                }
            }
        });
    };

    /**
     * 显示弹窗
     */
    handleShow = (type, item) => {
        let title;
        switch (type) {
            case "tableNumber":
                title = this.props.language["setEmptyTableCard"];
                break;
        }
        this.setState({
            show: true,
            type,
            title,
            formData: { ...formData },
            selectedData: { ...item },
        });
    };

    /**
     * 关闭弹窗
     */
    handleClose = () => {
        this.formRef.props.form.resetFields();
        this.setState({ show: false, formData: { ...formData } });
    };

    /**
     * 改变分页
     */
    hanldeChangePage = (pagination) => {
        this.setState(
            {
                queryParams: {
                    ...this.state.queryParams,
                    page: pagination.current,
                    limit: pagination.pageSize,
                },
            },
            () => this.fetchData()
        );
    };

    /**
     * 设置查询数据
     */
    handleSetQueryParamsData = (key, value) => {
        this.setState({
            queryParams: { ...this.state.queryParams, page: 1, [key]: value },
        });
    };

    /**
     * 重置
     */
    handleReset = () => {
        this.setState(
            {
                queryParams: {
                    page: 1,
                    limit: 20,
                    total: 0,
                    game_kind: undefined,
                },
            },
            () => {
                this.fetchData();
            }
        );
    };

    render () {
        return (
            <div className="main-container">
                {/* 表头 */}
                <div className="container-header">
                    <Select
                        allowClear
                        showSearch
                        optionFilterProp="children"
                        placeholder={this.props.language["gameTypePlaceholder"]}
                        value={this.state.queryParams.game_kind}
                        onChange={(value) =>
                            this.handleSetQueryParamsData("game_kind", value)
                        }
                    >
                        {this.state.kindList.map((item, index) => (
                            <Select.Option value={item.value} key={index}>
                                {item.label}
                            </Select.Option>
                        ))}
                    </Select>
                    <Button
                        type="primary"
                        icon="search"
                        loading={this.state.loading}
                        onClick={this.fetchData}
                    >
                        {this.props.language["query"]}
                    </Button>
                    <Button type="default" icon="reload" onClick={this.handleReset}>
                        {this.props.language["reset"]}
                    </Button>
                    <Button
                        type="danger"
                        ghost
                        onClick={() => this.handelCloseAllTable()}
                    >
                        {this.props.language["closeAllTable"]}
                    </Button>
                    <Button type="danger">
                        {this.props.language["diamondBalance"]}：{this.state.diamondBalance}
                    </Button>
                </div>

                {/* 内容 */}
                <div className="container-content">
                    <Table
                        dataSource={this.state.data}
                        // pagination={{ showTotal: total => `${this.props.language["total"]} ${total} ${this.props.language["item"]}`,  showQuickJumper: true, showSizeChanger: true, size: isMobileDevice() ? 'small' : '', pageSizeOptions: ['10', '20', '30', '40'], current: this.state.queryParams.page, pageSize: this.state.queryParams.limit, total: this.state.queryParams.total, size: isMobileDevice() ? 'small' : '', }}
                        pagination={false}
                        loading={this.state.loading}
                        onChange={this.hanldeChangePage}
                        scroll={{ x: true }}
                        rowKey={(record, index) => index}
                    >
                        <Table.Column
                            align="center"
                            title={this.props.language["configId"]}
                            dataIndex="conf_id"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["gambleName"]}
                            dataIndex="default_name"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["gameType"]}
                            dataIndex=""
                            render={(item) =>
                                item.kind === 4 ?
                                    this.state.subKindList.find(
                                        (item2) => item2.value === item.level.pokerExtra.gameType
                                    )
                                        ? this.state.subKindList.find(
                                            (item2) => item2.value === item.level.pokerExtra.gameType
                                        ).label
                                        : ""
                                    :
                                    this.state.kindList.find(
                                        (item2) => item2.value === item.kind
                                    )
                                        ? this.state.kindList.find(
                                            (item2) => item2.value === item.kind
                                        ).label
                                        : ""
                            }
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["level"]}
                            dataIndex=""
                            render={(item) => {
                                if (item.kind === 1 || item.kind === 4 || item.kind === 8) {
                                    return (
                                        parseFloat((item.level.sb / 100).toFixed(2)) +
                                        "/" +
                                        parseFloat((item.level.bb / 100).toFixed(2)) +
                                        "(" +
                                        parseFloat((item.level.ante / 100).toFixed(2)) +
                                        ")"
                                    );
                                } else if (item.kind === 2) {
                                    return parseFloat((item.level.ante / 100).toFixed(2));
                                } else if (item.kind === 6) {
                                    return parseFloat(
                                        (item.level.ofcExtra.multiple / 100).toFixed(2)
                                    );
                                }
                            }}
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["todayOpenTable"]}
                            dataIndex="today_opened"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["gambleProgress"]}
                            dataIndex="ongoing"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["openTable"]}
                            dataIndex="empty_seats"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["notBeginTable"]}
                            dataIndex="not_at_the"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["minEmptyTable"]}
                            dataIndex="keep_avail_tables"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["isAutoOpenTable"]}
                            dataIndex=""
                            fixed={isMobileDevice() ? false : "right"}
                            width={120}
                            render={(item) => {
                                return (
                                    <Switch
                                        checked={item.auto_create === 1}
                                        onChange={(value) =>
                                            this.handleSetAutoCreateTable(item.conf_id, value)
                                        }
                                    />
                                );
                            }}
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["operation"]}
                            dataIndex=""
                            fixed={isMobileDevice() ? false : "right"}
                            width={250}
                            render={(item) => (
                                <>
                                    <Button
                                        type="primary"
                                        className="mr10"
                                        ghost
                                        onClick={() => this.handleShow("tableNumber", item)}
                                    >
                                        {this.props.language["setEmptyTableCard"]}
                                    </Button>
                                    <Badge dot={item.today_opened === 0}>
                                        <Button
                                            type="primary"
                                            ghost
                                            onClick={() => this.handleCreateRound(item.conf_id)}
                                        >
                                            {this.props.language["createGambleTableRound"]}
                                        </Button>
                                    </Badge>
                                </>
                            )}
                        />
                    </Table>
                </div>

                {/* 表单弹窗 */}
                <FormModal
                    {...this.props}
                    visible={this.state.show}
                    type={this.state.type}
                    title={this.state.title}
                    formData={this.state.formData}
                    onOk={this.handleSubmit}
                    onCancel={this.handleClose}
                    wrappedComponentRef={(formRef) => (this.formRef = formRef)}
                />
            </div>
        );
    }
}

/**
 * 表单弹窗
 */
const FormModal = Form.create()(
    class FormBox extends React.Component {
        render () {
            const { getFieldDecorator } = this.props.form;
            return (
                <Modal
                    maskClosable={false}
                    width={600}
                    title={this.props.title}
                    visible={this.props.visible}
                    onOk={this.props.onOk}
                    onCancel={this.props.onCancel}
                    centered={isMobileDevice()}
                    bodyStyle={{
                        maxHeight: '70vh',
                        overflowY: "auto",
                    }}
                >
                    <div className="container-content">
                        <Form>
                            {/* 设置空位牌桌 */}
                            {this.props.type == "tableNumber" && (
                                <Form.Item label={this.props.language["minEmptyTable"]}>
                                    {getFieldDecorator("keep_avail_tables", {
                                        rules: [
                                            {
                                                required: true,
                                                message: this.props.language["minEmptyTableVerify"],
                                            },
                                        ],
                                        initialValue: this.props.formData.keep_avail_tables,
                                    })(
                                        <InputNumber
                                            min={0}
                                            max={100000000}
                                            precision={0}
                                            placeholder={
                                                this.props.language["minEmptyTablePlaceholder"]
                                            }
                                        />
                                    )}
                                </Form.Item>
                            )}
                        </Form>
                    </div>
                </Modal>
            );
        }
    }
);
